import React from 'react';
import { useTranslation } from 'react-i18next';
import { getHeaderSteps } from '../TradeInConstant';
import { TradeinV3HeaderProps } from '../TradeInInterface';

const TradeinV3Header: React.FC<TradeinV3HeaderProps> = ({ title, currentStep = 0, type, version }) => {
  const { t } = useTranslation();

  return (
    <div className='dy-stepper-form__header'>
      <h5 className='text-center title'>{title}</h5>
      <div className='wizard-steps'>
        <ol className='wizard-steps__list list-unstyled'>
          {getHeaderSteps(type, version, t)?.map(
            ({
              step,
              Icon,
              name,
              stepAllowed,
            }: {
              step: number;
              Icon: React.ComponentType;
              name: string;
              stepAllowed: number[];
            }) => {
              return (
                <li key={step} className={stepAllowed.includes(currentStep) ? 'complete' : ''}>
                  <div className='wizard-steps__step'>{`${step + 1}`}</div>
                  <div className='wizard-steps__icon'>
                    <Icon />
                  </div>
                  <div className='wizard-steps__name'>{name}</div>
                </li>
              );
            }
          )}
        </ol>
      </div>
    </div>
  );
};

export default TradeinV3Header;
